define('pimProductDetailImagesView',[
  'app',
  'module',
  'marionette',
  'backbone',
  'settings',
  'underscore',
  'contextMenu',
  'pimProductDetailImageView'
], function (
  App,
  Module,
  Marionette,
  Backbone,
  Settings,
  _,
  ContextMenu,
  ImageView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    className: 'pim-products-details-images-view',
    childView: ImageView,

    /** The reseller sheet, for the badge saying what is placed on each picture. */
    childViewOptions: function () {
      return {pimProduct: this.model};
    },

    initialize: function () {
      this.collection = new Backbone.Collection();
    },

    onShow: function () {
      this.fetch();
      // The right-click menu on these pictures is the overview's: it holds the
      // print-area positioner as well, which needs the reseller sheet.
    },

    fetch: function () {
      if(this.model.get('data') && this.model.get('data').get('productPictures')) {
        this.collection.set(this.model.get('data').get('productPictures'));
      }
    },

    selectImage: function (url) {
      var formData = new FormData();

      var fd = {};

      fd.imageUrl = url;

      _.each(fd, function (value, key) {
        formData.append(key, value);
      });

      App.request('pim:products:update-catalog-picture-from-url',
          this.model.getCurrentResProduct().get('id'),
          formData).done(_.bind(function (response) {
          this.model.getCurrentResProduct().set('catalogPictureUid', response.catalogPictureUid);
        }, this))
        .fail(_.bind(function () {
        }, this));
    }
  });
});
